<div>
  <div>
    <div
      *ngIf="title"
      [class]="options.titleClass"
      [attr.aria-label]="title"
      class="fz-16"
    >
      {{ title }}
    </div>

    <div
      *ngIf="message && !options.enableHtml"
      role="alert"
      aria-live="polite"
      class="fw-normal"
      [class]="options.messageClass"
      [attr.aria-label]="message"
    >
      {{ message }}
    </div>
  </div>

  <div class="d-flex justify-content-end mt-2">
    <a class="button-outline w-154px mr-3" (click)="logout()"> Signed Out </a>

    <a class="button w-184px" (click)="refreshToken()">
      Stay signed in ({{ (timer$ | async) ?? 0 | timer }})
    </a>
  </div>

  <div class="toast-loader" [class.loading]="isLoading"></div>
</div>
